import React, { useEffect } from 'react'
import ReactLoading from 'react-loading';
import { useStyles } from '../../../styles/LoaderStyles';
import logo from '../../../../assets/images/insights-engine.png'
import logoWhite from '../../../../assets/images/insights-engine-white.png'
import { useSelector } from 'react-redux';

function Loader({ children, type, color, isLoading }){
	useStyles()
	const useDarkMode = useSelector(state => state.session.useDarkMode)
	const localDMode = localStorage.getItem("useDarkMode") !== null
	if (isLoading) {

		return <>
			<div className="d-flex justify-content-center">
				<img src={localDMode || useDarkMode ? logoWhite : logo} style={{height: "80px", flexWrap: "nowrap"}} />
				<ReactLoading className="align-self-center" type={type} color={localDMode || useDarkMode ? "white" : color} height={'50px'} width={'50px'} />
			</div>
	    </>;
	}

  	return children;
}

export default Loader;